import gql from 'graphql-tag';
import { handleClick } from './useClickableProps';

export const EventCoreAttributesWithContext = `
id
eventType
message
contextSpecificMessage
isViewed
createdAt
user {
  id
  name
  avatarUrl
  avatarColor
  isSuperUser
}
siteId
groupId
pageId
taskId
`;

export const EventCoreAttributesWithContextAndChanges = `
${EventCoreAttributesWithContext}
recordChanges
`;

export const buildEventFragment = (attributes, fragmentName = 'EventFragment') => (gql`
  fragment ${fragmentName} on Event {
    ${attributes}
  }
`);

export const determineEventSourceHref = (message) => {
  if (!message) return null;

  let href = '';
  if (message.taskId) {
    href = `/tasks/${message.taskId}`;
  } else if (message.siteId) {
    href = `/sites/${message.siteId}`;
    if (message.pageId) href += `/pages/${message.pageId}`;
  }

  return href;
}

export const navigateToEventSource = (event, message) => {
  const href = determineEventSourceHref(message);
  if (!href) return;
  handleClick(event, { href });
};

const issueEvents = ['asset_issue_ignored', 'asset_issue_unignored', 'page_issue_ignored', 'page_issue_unignored', 'site_issue_ignored', 'site_issue_unignored', 'group_issue_ignored', 'group_issue_unignored', 'account_issue_ignored', 'account_issue_unignored'];
const taskEvents = ['task_assigned', 'task_resolved', 'task_reopened'];
const crawlEvents = ['site_crawl_finished', 'site_enabled', 'site_disabled'];
const mentionEvents = ['page_comment_mentioned', 'task_comment_mentioned'];
const commentEvents = ['page_comment_added', 'task_comment_added'];
const uptimeEvents = ['site_uptime_status_changed'];

export const accountEventGroups = {
  userAuth: ['user_sign_in_with_password_success', 'user_sign_in_with_password_failure', 'user_sign_in_with_sso_success', 'user_sign_in_with_sso_failure', 'user_sign_out'],
  issues: ['account_issue_ignored', 'account_issue_unignored'],
  sites: ['site_created', 'site_updated', 'site_deleted', 'site_enabled', 'site_disabled'],
  users: ['account_user_added', 'account_user_removed', 'account_user_role_changed', 'group_user_role_changed', 'site_user_role_changed'],
  groups: ['group_created', 'group_updated', 'group_deleted'],
  connectors: ['connector_created', 'connector_updated', 'connector_deleted'],
  reportTemplates: ['report_template_created', 'report_template_updated', 'report_template_deleted'],
  customChecks: ['custom_check_created', 'custom_check_updated', 'custom_check_deleted', 'policy_set_imported', 'policy_set_removed'],
}
export const accountEvents = Object.values(accountEventGroups).flat();

export const siteAndGroupActivityEventGroups = {
  sites: ['site_updated'],
  groups: ['group_updated'],
  issues: issueEvents.filter(event => !event.startsWith('account')),
  pages: ['page_ignored_by_user'],
  tasks: taskEvents,
  crawls: crawlEvents,
  comments: commentEvents,
  uptime: uptimeEvents,
};
export const siteAndGroupActivityEvents = Object.values(siteAndGroupActivityEventGroups).flat();

export const defaultFilterSettings = { issues: true, tasks: true, crawls: true, mentions: true, comments: true, uptime: true, previouslyViewed: false };

export function buildEventTypes(filterSettings) {
  const eventTypes = [];

  filterSettings.issues && eventTypes.push(...issueEvents);
  filterSettings.tasks && eventTypes.push(...taskEvents);
  filterSettings.crawls && eventTypes.push(...crawlEvents);
  filterSettings.mentions && eventTypes.push(...mentionEvents);
  filterSettings.comments && eventTypes.push(...commentEvents);
  filterSettings.uptime && eventTypes.push(...uptimeEvents);

  return eventTypes;
}
